export default __webpack_public_path__ + "static/media/connecting_web-xs@2x.e6a35e71.webp";